import "./index.scss";
import React, { FunctionComponent } from "react";

type WidgetProps = {
  label: string;
  price: number;
};

type SchedulingOptionsProps = {
  options: Array<WidgetProps | any>;
  selectedOption: string;
  handleOptionSelection: Function;
  spell: string;
};

const spellClassMap: { [key: string]: string } = {
  widget: "pricing",
  duration: "weeks",
};

export const SchedulingOptions: FunctionComponent<SchedulingOptionsProps> = ({
  options,
  selectedOption,
  handleOptionSelection,
  spell,
}) => {
  const renderWidgets = () => {
    return options.map((w) => (
      <li
        key={w.label}
        className={selectedOption === w.uuid ? "selected" : ""}
        onClick={() => handleOptionSelection(w.uuid)}
      >
        <span className="label">{w.label}</span>
        <span className="price">
          ${w.price}
          <span className="price-label">per week</span>
        </span>
      </li>
    ));
  };

  const renderCalendars = () => {
    return options.map((w) => (
      <li
        key={w}
        className={`${selectedOption}` === `${w}` ? "selected" : ""}
        onClick={() => handleOptionSelection(w)}
      >
        <span className="label">{w} week</span>
        <span className="calendar">
          {[1, 2, 3, 4].map((week) => (
            <div key={week}>
              {[...Array(7)].map((item, index) => (
                <span key={index} className={`dot ${week <= w ? "active" : ""}`}></span>
              ))}
            </div>
          ))}
        </span>
      </li>
    ));
  };

  return (
    <form>
      <ul className={`grid radio ${spellClassMap[spell]}`}>
        {spell === "widget" && renderWidgets()}
        {spell === "duration" && renderCalendars()}
      </ul>
    </form>
  );
};

export default SchedulingOptions;
